import {isEmpty, isNil} from 'ramda';
import {isNilOrEmpty} from 'ramda-adjunct';

import type {CheckoutProfileMissing, CheckoutProfileWrite} from '../types';
import {
  getCheckoutProfileDocumentCells,
  getCheckoutProfileDocumentCellKey,
} from '../utils/getCheckoutProfileDocumentCells';

export function getCheckoutProfileMissing(profile: CheckoutProfileWrite) {
  const missing: CheckoutProfileMissing[] = [];
  if (profile.typeOfSale === 'DEFAULT') {
    const methods = profile.payments?.methods ?? [];
    if (isEmpty(methods)) {
      missing.push({tab: 'PAYMENTS', code: 'PAYMENT_METHOD_NONE'});
    }
    if (
      profile.foreignCurrency?.isAllowed === true &&
      isNilOrEmpty(profile.foreignCurrency.defaultCurrency)
    ) {
      missing.push({tab: 'GENERAL', code: 'FOREIGN_CURRENCY_MISSING'});
    }
    if (profile.deposit?.isAllowed) {
      const depositMethods = profile.deposit.methods ?? [];
      if (isEmpty(depositMethods)) {
        missing.push({tab: 'DEPOSIT', code: 'DEPOSIT_METHOD_NONE'});
      }
      if (
        isNil(profile.deposit.defaultMethod) ||
        !depositMethods.includes(profile.deposit.defaultMethod)
      ) {
        missing.push({tab: 'DEPOSIT', code: 'DEFAULT_DEPOSIT_METHOD_MISSING'});
      }
      if (depositMethods.includes('BANK_TRANSFER') && isNil(profile.deposit.maturityDays)) {
        missing.push({tab: 'DEPOSIT', code: 'DEPOSIT_MATURITY_MISSING'});
      }
    }
  }
  const configured = new Set(profile.documents.map(getCheckoutProfileDocumentCellKey));
  getCheckoutProfileDocumentCells(profile).forEach((cell) => {
    if (!configured.has(getCheckoutProfileDocumentCellKey(cell))) {
      missing.push({tab: 'DOCUMENTS', code: 'DOCUMENT_ROW_MISSING', ...cell});
    }
  });
  return missing;
}
